// @flow
import {
  WebComponent,
} from 'fg-frontend';
import $ from 'jquery';

export default class GreedyMenu extends WebComponent {
	constructor(props) {
		super(props);
		this.updateNav = this.updateNav.bind(this);
	}
	didMount() {
		const self = this;

    if ($(this.element).is(':visible')) {
      this.nav = $(this.element).find('.greedy-menu__container');
      this.btn = this.nav.find('.greedy-menu__btn');
      this.vlinks = this.nav.find('.greedy-menu__visible-links');
      this.hlinks = this.nav.find('.greedy-menu__hidden-links');
      this.breaks = [];


      // Window listeners
      $(window).resize(function () {
        self.updateNav();
      });

      this.btn.find('a').on('click', function (e) {
        self.hlinks.toggleClass('hidden');
        e.preventDefault();
      });

      this.updateNav();
    }
	}


	updateNav() {
		var availableSpace = this.btn.hasClass('hidden') ? this.nav.width() : this.nav.width() - this.btn.innerWidth() - 4;

		// The visible list is overflowing the nav
		if (this.vlinks.width() > availableSpace) {

			// Record the width of the list
			this.breaks.push(this.vlinks.width());

			// Move item to the hidden list
			this.vlinks.children().last().prependTo(this.hlinks);

			// Show the dropdown btn
			if (this.btn.hasClass('hidden')) {
				this.btn.removeClass('hidden');
			}

			// The visible list is not overflowing
		} else {

			// There is space for another item in the nav
			if (availableSpace > this.breaks[this.breaks.length - 1]) {

				// Move the item to the visible list
				this.hlinks.children().first().appendTo(this.vlinks);
				this.breaks.pop();
			}

			// Hide the dropdown btn if hidden list is empty
			if (this.breaks.length < 1) {
				this.btn.addClass('hidden');
				this.hlinks.addClass('hidden');
			}
		}

		// Recur if the visible list is still overflowing the nav
		if (this.vlinks.width() > availableSpace) {
			this.updateNav();
		}
	}

}



// WEBPACK FOOTER //
// ./config/module-publish/resources-3dliving/js/components/GreedyMenu.js